import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSection } from "../../services/section";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteSection = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteSection,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["questionnaire_content"] });
                indicator.setIsProcessRunning(false);
                toast.success("Section deleted successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useDeleteSection;